<div class="answer-page-container">
  <div class="answer-page-nav-bar box">
    <div class="answer-page-nav-bar-title">{{ title }}</div>
    <div class="answer-page-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="answer-page-holder">
    <div class="box" *ngIf="answer">
      <div class="answer-box">
        <p style="font-family: Vazir-Medium !important;">{{ answer.question }}</p>
        <p>
          {{ answer.answer }}
        </p>
      </div>
      <div class="answer-box-footer">
        <div style="width: 186px;">
          <p>این سوال به شما کمک کرد ؟</p>
        </div>
        <div class="answer-box-vote" style="width: 120px; height: 48px; position: relative;">
          <button class="answer-box-vote-yes" (click)="vote('like')" style="left: 60px;">
            <img
              [src]="
                userReaction === 'like'
                  ? 'assets/setting/like-solid.svg'
                  : 'assets/setting/like.svg'
              "
              alt="" style="top: 6px; position: relative;"
            />
          </button>
          <button class="answer-box-vote-no" (click)="vote('dislike')" style="left: 4px;">
            <img
              [src]="
                userReaction === 'dislike'
                  ? 'assets/setting/dislike-solid.svg'
                  : 'assets/setting/dislike.svg'
              "
              alt="" style="top: 6px; position: relative;"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="problem-report" (click)="openSendReport()">
      <button>گزارش مشکل</button>
    </div>
  </div>
  <app-edit-bottomsheet
    *ngIf="showEdit"
    [type]="selectedType"
    [faqId]="id"
  ></app-edit-bottomsheet>
</div>
